import React from 'react';
import '../css/style.css';

const Mantenimiento = () => {
  return (
    <div className="mantenimiento-container">
      <div className="mantenimiento-content">
        <img 
          src="/images/logoadhoc.svg"
          alt="Adhoc Logo" 
          className="mantenimiento-logo"
        />
        <h1>En mantenimiento</h1>
        <p>
          Nuestros desarrolladores están trabajando en este sitio para mejorar tu experiencia.
          Por favor, vuelve a intentarlo en unos minutos.
        </p>
        <p className="mantenimiento-footer">
          Teléfono de urgencias: {' '}
          <a href="tel:+34856901276">856 901 276</a>
        </p>
      </div>
    </div>
  );
};

export default Mantenimiento;
